module.exports = __webpack_public_path__ + "static/james-ed7914f2526c01bb2b8b1fb5f767fb8a.jpg";